@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

[data-fpsm-theme='gazzetta'] {
  .closeButton svg {
    color: var(--cxy-color-text-default-body);
  }
}

.dialog {
  background-color: var(--cxy-color-surface-default);
  color: var(--cxy-color-text-default-body);
  border-radius: var(--cxy-border-radius-m);
  border: none;
  padding: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  margin-top: 88px;
  margin-inline: var(--cxy-spacing-xsm);

  &:focus-visible {
    @include cxy.focus-ring;
  }

  &.hasBackdrop {
    &[open]::backdrop {
      background-color: color-mix(in srgb, var(--cxy-color-surface-default), transparent 60%);
    }
  }

  &:modal.isFullScreen {
    margin: 0;
    height: 100vh;
    width: 100vw;
    max-width: none;
    max-height: none;
    padding: var(--cxy-spacing-xxsm) var(--cxy-spacing-xsm);
    border-radius: 0;

    .closeButtonWrapper {
      display: block;
      margin-block-end: 56px;
      width: 100%;
      text-align: end;
    }
  }

  @include cxy.screen-size('tablet') {
    margin-top: auto;
    margin-inline: auto;
  }
}

.dialogWrapper {
  display: flex;
  flex-direction: column;

  @include cxy.screen-size('tablet') {
    flex-direction: row;
  }
}

.closeButtonWrapper {
  display: none;
}

.panel {
  padding: var(--cxy-spacing-sm) var(--cxy-spacing-xsm);

  @include cxy.screen-size('tablet') {
    padding: var(--cxy-spacing-sm);
  }
}
